import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { personalInfo } from '../data/mock';
import { Linkedin, ExternalLink, Globe, Heart, HelpCircle, User, Clock } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

const Footer = () => {
  const { theme } = useTheme();
  const bgColor = theme.colors.backgroundDark;
  const accentColor = theme.colors.accent;

  return (
    <footer className="py-12 text-white" style={{ backgroundColor: bgColor }}>
      <div className="container mx-auto px-6">
        <div className="mb-8 grid gap-8 md:grid-cols-3">
          {/* About */}
          <div>
            <div className="mb-4 flex items-center gap-3">
              <img src={personalInfo.logo} alt="VJS Logo" className="h-12 w-12 object-contain" />
              <h3 className="font-serif text-2xl font-bold">{personalInfo.name}</h3>
            </div>
            <p className="mb-4 text-sm leading-relaxed opacity-80">
              Director of Operations | Global Talent Acquisition Leader | Founder of RecruiterIQ
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="mb-4 text-lg font-semibold" style={{ color: accentColor }}>
              Quick Links
            </h4>
            <ul className="space-y-2 text-sm">
              <li>
                <RouterLink
                  to="/recruiteriq"
                  className="flex items-center gap-2 opacity-80 transition-all hover:opacity-100 hover:underline"
                >
                  <Globe className="h-4 w-4" />
                  RecruiterIQ
                </RouterLink>
              </li>
              <li>
                <a
                  href={personalInfo.socialLinks.wiki}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 opacity-80 transition-all hover:opacity-100 hover:underline"
                >
                  <ExternalLink className="h-4 w-4" />
                  Wiki Biography
                </a>
              </li>
              <li>
                <RouterLink
                  to="/biography"
                  className="flex items-center gap-2 opacity-80 transition-all hover:opacity-100 hover:underline"
                >
                  <User className="h-4 w-4" />
                  Biography
                </RouterLink>
              </li>
              <li>
                <RouterLink
                  to="/career"
                  className="flex items-center gap-2 opacity-80 transition-all hover:opacity-100 hover:underline"
                >
                  <Clock className="h-4 w-4" />
                  Career Timeline
                </RouterLink>
              </li>
              <li>
                <RouterLink
                  to="/faq"
                  className="flex items-center gap-2 opacity-80 transition-all hover:opacity-100 hover:underline"
                >
                  <HelpCircle className="h-4 w-4" />
                  FAQ
                </RouterLink>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h4 className="mb-4 text-lg font-semibold" style={{ color: accentColor }}>
              Connect
            </h4>
            <div className="flex gap-4">
              <a
                href={personalInfo.socialLinks.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-full p-3 transition-all hover:scale-110"
                style={{ backgroundColor: accentColor }}
              >
                <Linkedin className="h-5 w-5" style={{ color: bgColor }} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 text-center text-sm opacity-60">
          <p className="flex items-center justify-center gap-2">
            © {new Date().getFullYear()} {personalInfo.name}. Built with
            <Heart className="h-4 w-4 fill-current" style={{ color: accentColor }} />
            for excellence.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
